import { motion, useMotionValue, useSpring } from 'framer-motion';
import { useEffect } from 'react';

const CursorFollower = () => {
  const mouseX = useMotionValue(-100);
  const mouseY = useMotionValue(-100);

  // Add smooth spring-like movement to cursor
  const springX = useSpring(mouseX, { stiffness: 450, damping: 70 });
  const springY = useSpring(mouseY, { stiffness: 450, damping: 70 });

  useEffect(() => {
    const moveCursor = (e) => {
      // e.clientX / e.clientY = mouse coordinates relative to viewport
      // Subtract 12 to center the 24x24px ball
      mouseX.set(e.clientX - 2);
      mouseY.set(e.clientY - 2);
    };

    window.addEventListener('mousemove', moveCursor);
    return () => window.removeEventListener('mousemove', moveCursor);
  }, [mouseX, mouseY]);

  return (
    <motion.div
      style={{ 
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        backgroundColor: '#375e81',
        position: 'fixed',
        top: 0,
        left: 0,
        translateX: springX,
        translateY: springY,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    />
  );
};

export default CursorFollower;
